export enum ButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum ButtonType {
  BUTTON = 'button',
  SUBMIT = 'submit',
}

export interface ButtonProps {
  text?: string;
  disabled?: boolean;
  icon?: React.JSX.Element;
  type?: ButtonType;
  onClick?: () => void;
  className?: string;
  size?: ButtonSize;
  bold?: boolean;
  onMouseEnter?: () => void;
  tabIndex?: number;
  iconPosition?: 'left' | 'right';
}
